import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-like-solid",
  "use": "icon-like-solid-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" id=\"icon-like-solid\"><path d=\"M10.9 3c-.8 0-1.6.3-2.2.9l-.7.7-.7-.7C6.7 3.3 5.9 3 5.1 3s-1.6.3-2.2.9c-1.2 1.2-1.2 3.4 0 4.7C4.2 10 8 14 8 14s3.8-4 5.1-5.4c1.2-1.2 1.2-3.5 0-4.7-.6-.6-1.4-.9-2.2-.9\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol